import React from 'react';
import Modal from './Modal';
import Button from './Button';

const ConfirmDialog = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = 'Confirm Action',
  message = 'Are you sure you want to proceed?',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  type = 'danger' // danger, warning, info
}) => {
  const iconStyle = {
    fontSize: '48px',
    textAlign: 'center',
    marginBottom: '16px'
  };

  const messageStyle = {
    fontSize: '15px',
    color: 'var(--text-primary)',
    lineHeight: '1.6',
    textAlign: 'center'
  };

  const icons = {
    danger: '',
    warning: '',
    info: ''
  };

  const footer = (
    <>
      <Button variant="secondary" onClick={onClose}>
        {cancelText}
      </Button>
      <Button variant="danger" onClick={onConfirm}>
        {confirmText}
      </Button>
    </>
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="small"
      footer={footer}
    >
      <div style={iconStyle}>{icons[type]}</div>
      <div style={messageStyle}>{message}</div>
    </Modal>
  );
};

export default ConfirmDialog;